import { Form, Formik } from "formik";

import { CloseOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Space, Tag, Button } from "antd";
import { Input, Select } from "components/form";

import styles from "../styles/UserManagement.module.css";
import { useTranslation } from "react-i18next";

const STATUS = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  { label: "Inactive", value: "INACTIVE" },
];

const tagRender = (props) => {
  const { label, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable={false}
      onClose={onClose}
      style={{
        border: "1px solid var(--font, #2BA4DD)",
        borderRadius: "59px",
        marginRight: 3,
        color: "var(--font, #2BA4DD)",
        display: "flex",
        alignItems: "center",
        padding: "4px 8px",
      }}
    >
      {label}
      <CloseOutlined style={{ marginLeft: 4 }} onClick={onClose} />
    </Tag>
  );
};
function UserForm({
  isLoading = false,
  isModalOpen = false,
  initialValues = {},
  onSubmit = () => { },
  onCancel = () => { },
  handleOk = () => { },
  roleOptions = [],
  back = "BACK",
  submit = "SUBMIT"
}) {

  // const { roleOptions = [] } = useUserRole()
  const { t, i18n } = useTranslation();

  return (
    <Modal
      open={isModalOpen}
      handleOk={handleOk}
      onCancel={() => {
        const cancelBtn = document.getElementById(
          "cancelBtn"
        );
        if (cancelBtn) {
          cancelBtn.click();
        } else {
          onCancel();
        }
      }}
      footer={null}
      destroyOnClose
      closable={false}
      maskClosable={false}
    >
      <Formik
        enableReinitialize
        initialValues={{
          ...initialValues,
          role: initialValues?.role?.map((o) => o?.id),
        }}
        // validationSchema={schema}
        onSubmit={(values) => {
          onSubmit(values, onCancel)
        }}
      >{({ submitForm, values = {}, resetForm = () => { } }) => {
        return (
          <Form className={styles.formContainer}
          // onFinish={submitForm}
          >
            <Space direction="vertical" size={24}>
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <Input
                    disabled
                    name="username"
                    placeholder="E-mail"
                    size="large"
                    label={t('stpRole.email')}
                  />
                </Col>

              </Row>
              <Row gutter={[0, 24]}>
                <Col span={12} style={{ paddingRight: "8px" }}>
                  <Input disabled name="name" placeholder="Name" size="large" label={t('signup.input.name')} />
                </Col>
                <Col span={12} style={{ paddingLeft: "8px" }}>
                  <Input
                    disabled
                    name="surName"
                    placeholder="Surname"
                    size="large"
                    label={t('employee.label.surname')}
                  />
                </Col>
                {/* <Col span={12}>
                <Input
                  type="password"
                  name="password"
                  placeholder="Password"
                  size="large"
                  label="Password"
                />
              </Col> */}
                {/* <Col span={12}>
                  <Select
                    size="large"
                    label="Status"
                    name="userRegister.userStatusFlag"
                    options={STATUS}
                  />
                  <Switch
                    name="enableTimeLock"
                    label="Status"
                  />
                </Col> */}
              </Row>
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Select
                    size="large"
                    label={t('user_management.label.role')}
                    name="roles"
                    mode="multiple"
                    required
                    tagRender={tagRender}
                    options={roleOptions}
                  />
                </Col>

              </Row>

              <Row justify={"end"}>
                <Space direction="horizontal" size={12}>
                  <Button
                    id="cancelBtn"
                    key="cancel"
                    type="default"
                    onClick={() => {
                      onCancel();
                      resetForm();
                    }}
                    style={{ height: "40px", borderRadius: "8px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button
                    htmlType="submit"
                    type="primary"
                    className={styles.cancelSave}
                    style={{ height: "40px", backgroundColor: "var(--button-color)", borderRadius: "8px" }}
                  >
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Space>
              </Row>

            </Space>
          </Form>)
      }}
      </Formik>
    </Modal>
  );
}

export default UserForm;
